/*

    Dumb Component - just to display the table with the data and the transition.

*/
import React, { useContext } from "react";
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { Row, Col } from "reactstrap";
import { ThemeContext } from "corp-site/employer/context/ThemeContext";

const RecentTableDisplay = ({ items }) => {
    const context = useContext(ThemeContext)
    return (
        <TransitionGroup>
            {items.map((candidate) => (
                <CSSTransition
                    key={candidate.userId}
                    timeout={500}
                    className="recent_table_item"
                    classNames="recent_table_item"
                >
                    <div
                        style={{ cursor: "pointer", position: "relative", zIndex: "200" }}
                        onClick={() => { window.location.href = "/employers?register=y" }}
                    >
                        <Row noGutters className="d-flex">
                            <Col xs="8" md="3" className="order-1" ><div className="text-truncate pr-1" ><b>{candidate.fname + " " + candidate.lname}.</b></div></Col>
                            <Col xs="4" className="d-md-none order-2 text-center" ><small><b>Applied</b></small></Col>
                            <Col md="4" xs="8" className="order-3" ><div className="text-truncate px-md-1" >{candidate.keyword}</div></Col>
                            <Col md="3" className="order-5" ><div className="text-truncate px-md-1" >{candidate.location}</div></Col>
                            <Col xs="4" md="2" className="order-4 order-md-12" ><div className={"text-center text-md-left text-truncate pl-1 " + (context ? " text-dark-" + context : "")} ><small>{candidate.formattedTime}</small></div></Col>
                        </Row>
                    </div>
                </CSSTransition>
            ))}
        </TransitionGroup>
    )

}


export default RecentTableDisplay;